<template>
  <div class="campaign-page">
    <div>
      <CampaignHeader
        v-if="iplCampaignHeader.length"
        :menuItems="iplCampaignHeader"
        isIPLCampaign
      />
      <router-view class="flex-col"></router-view>
      <CampaignFooter
        v-if="campaignFooter.length"
        :footerLinks="campaignFooter"
      />
    </div>
    <ConsentComponent :showCountdownPopup="showCountdownPopup"/>
    <LandingSvg />
    <RzAllSvg />
  </div>
</template>

<style lang="scss">
</style>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import LandingSvg from '@/components/Svg/LandingSvg.vue';
import RzAllSvg from '@/components/Svg/RzAllSvg.vue';
import CampaignHeader from '@/components/SportsHome/CampaignHeader.vue';
import CampaignFooter from '@/components/SportsHome/CampaignFooter.vue';
import CookieManager from '@/core/utils/cookieManager';
import ConsentComponent from './ConsentComponent.vue';

export default {
  name: 'CampaignBase',
  components: {
    CampaignHeader,
    CampaignFooter,
    LandingSvg,
    RzAllSvg,
    ConsentComponent,
  },
  data() {
    return {
      showCountdown: false,
    };
  },
  computed: {
    ...mapState({
      dataLoaded: (state) => state.page.activePageState.status.isLoaded,
      iplCampaignHeader: (state) => state.link.iplCampaignHeader.links,
      campaignFooter: (state) => state.link.campaignFooter.links,
    }),
  },
  serverPrefetch() {
    return this.fetchData();
  },
  mounted() {
    console.log('dataLoaded:', this.dataLoaded);
    if (!this.dataLoaded) {
      this.fetchData();
    }
    let urlParams;
    let utmSource = null;
    let utmId = null;

    try {
      urlParams = new URLSearchParams(window.location.search);
      utmSource = urlParams.get('utm_source');
      utmId = urlParams.get('utm_id');

      if ((!utmSource && window.location.search.includes('%3D'))
      || (!utmId && window.location.search.includes('%3D'))) {
        const decodedSearch = decodeURIComponent(window.location.search);
        urlParams = new URLSearchParams(decodedSearch);
        utmSource = urlParams.get('utm_source');
        utmId = urlParams.get('utm_id');
      }
    } catch (e) {
      console.error('Error parsing URL parameters:', e);
    }
    if (utmSource) {
      CookieManager.setItem('source_medium',
        utmSource, moment().add(30, 'day').toDate(), '/');
    }
    if (utmId) {
      CookieManager.setItem('source_id',
        utmId, moment().add(30, 'day').toDate(), '/');
    }
  },
  methods: {
    showCountdownPopup() {
      this.showCountdown = true;
    },
    fetchData() {
      return this.$store.dispatch('link/fetchIplCampaignHeader').then(() => {
        return this.$store.dispatch('link/fetchCampaignFooter');
      });
    },
    refreshPage() {
      this.$store.commit('page/resetActivePage');
      this.fetchData();
    },
  },
};
</script>
